export default function hasInternetConnection(): boolean {
  const onLine = window.navigator.onLine
  const isOnLinePropertySupportedByBrowser = typeof onLine === 'boolean'

  // If a browser supports the onLine property we'll use its value
  if (isOnLinePropertySupportedByBrowser) { return onLine }

  return true
}
